//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'leon-sign-out',
  data () {
    return {
      isShow: true,  // 控制显示隐藏
      secNum: 5,     // 秒钟
      timer: null
    }
  },
  mounted () {
    this.signOut()
  },
  methods: {
    signOut () {
      this.timer = setInterval(() => {
        this.secNum--
        if (this.secNum === 0) {
          clearInterval(this.timer)
          this.isShow = false
          window.location = this.$config.return_url
        }
      }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSignOut/src/main.vue